
import req from "../commons/request";
import Query from './../commons/mv-ol/query/query';

export var _APP = "";
if (process.env.NODE_ENV === "development") {
    _APP = "/geosite";
} else if (process.env.NODE_ENV === "production") {
    _APP = "//geosite.mapvision.com.cn";
} else if (process.env.NODE_ENV === "test") {
    _APP = "/";
}

export const payByAnt = _APP + "/rest/expense/zhifubao?id=";
//高德接口
const _AMAP = "//restapi.amap.com/v3";
const _SEARCH_POI = _AMAP + "/place/text";
//地理编码
const  _GEO = _AMAP + "/geocode/geo"
//逆向地址编码
const _REGEO = _AMAP + "/geocode/regeo";
//AOI查询  https://www.amap.com/detail/get/detail?id=B000A83JJ1
const _DETAIL = "/detail/get/detail"
//临时key
// const key = "19790a2fb5ed91ee04e1cb1da42450b3";
const key = "80c74b649c89d571a807f591b9acf903";
//支付宝接口
export const alipay = "/rest/expense/zhifubao?id=";
export const getWeixinCode = (id) => {
    return req.get(_APP + "/rest/weixin/weiXinPay?ids=" + id);
}
export const checkPay = () => {
    return req.get(_APP + "/rest/weixin/hadPay");
}
//地图查询
export const query = new Query();

export const getCitylist = () => {
    return req.get(_APP + "/rest/format/findProvCityList.json");
}

export const getCitylistByCity = () => {
    return req.get(_APP + "/rest/format/findProvCityListByCity.json")
}
//poi查询
export const searchPOI = (keywords, adcode, page, types) => {
    let params = {
        keywords: keywords,
        city: adcode,
        citylimit: true,
        offset: 25,
        page: page,
        key: key
    }
    if (types) {
        params.types = types;
    }
    return req.jsonp(_SEARCH_POI, params, "callback");
}
//AOI查询
export const searchAOI = (id) => {
    let params  = {
        id: id
    }
    return req.jsonp("www.amap.com/detail/get/detail", params, "callback");
    // return req.get(_DETAIL , {
    //     params: params
    // })
}
//地理编码
export const geocoding = (address) => {
    let params = {
        output: "json",
        address:address,
        key: key,
    }
    // return req.get(_GEO, {
    //     params: params
    // });
    return req.jsonp(_GEO, params, "callback");
}
//逆向地址编码
export const regeocoding = (coordinates) => {
    let params = {
        output: "json",
        location: coordinates.join(","),
        key: key,
        raidus: 500,
        extensions: "all"
    }
    return req.get(_REGEO, {
        params: params
    });
}
//获取指标配置
export const getParamsList = (id) => {
    let params = {
        id: id
    }
    return req.get(_APP + "/rest/params/children", {
        params: params
    })
}
//获取所有指标
export const getAllParamsList = () => {
    return req.get(_APP + "/rest/params/list")
}

//提交订单
export const submmitOrder = (params) => {
    return req.post(_APP + "/rest/download/addOrder", params)
}
//登录
export const login = (username, password, verify) => {
    return req.post(_APP + "/login", { username: username, password: password, verify: verify });
}
//加载报告配置
export const loadReportConfig = (tradeno) => {
    return req.post(_APP + "/rest/download/searchReportTarget", { tradeno: tradeno });
}
//加载报告配置
export const loadReportConfigByid = (id) => {
    return req.post(_APP + "/rest/download/findReportById", { id: id });
}
//获取订单列表
export const loadReportData = (tradeno) => {
    return req.post(_APP + "/rest/format/findGaoDeDataList", { tradeno: tradeno });
}
//获取短信验证码
export const getSmsCode = (phone) => {
    return req.post(_APP + "/rest/smsCode/getSmsCode", { phoneNum: phone });
}
//注册用户
export const regist = (name, password, phone, idenCode, provinces = "北京市", city = "北京市") => {
    return req.post(_APP + "/rest/user/addUser", { name, password, phone, idenCode, provinces, city, fid: -1, did: -1, formats: "", formats_detail: "" })
}
//获取已支付订单列表
export const getReports = (page, count) => {
    return req.post(_APP + "/rest/download/findExpenseRecord");
}
//忘记密码
export const checkPhone = (phone, code) => {
    return req.post(_APP + "/rest/user/checkCode", {
        phone: phone,
        code: code
    })
}
export const resetPassword = (password) => {
    return req.post(_APP + "/rest/user/updatePassword", {
        password: password
    });
}
//删除报告
export const removeReport = (id) => {
    return req.post(_APP + "/rest/download/remove", { id: id })
}

//个人信息
export const getUserInfo = (id) => {
    return req.post(_APP + "/rest/user/findUserInfoMessage", { id: id })
}

//修改手机号
export const updatePhoneNumber = (phone, smsCode) => {
    return req.post(_APP + "/rest/user/updateUserPhone", {
        phone: phone,
        smsCode: smsCode
    })
}

//修改密码
export const updatePassword = (oldPassword, newPassword) => {
    return req.post(_APP + "/rest/user/updatePasswordByPassword", {
        password: oldPassword,
        newpwd: newPassword
    })
}

//下载报告
export const downloadReport = (id, tradeno) => {
    return _APP + `/rest/upload/DownloadReport?id=${id}&tradeno=${tradeno}`;
};

//获取预付款剩余次数
export const getRemainTimes = () => {
    return req.get(_APP + "/rest/prepay/redidueDegree")
}

//扣除次数
export const deductTimes = (count,id) => {
    return req.post(_APP + "/rest/prepay/residueDegreeDecrease", { 
        count:count,
        ids: id
    })
}